// extracted by mini-css-extract-plugin
export default {"switch":"LanguageSelectionMenu_switch__+reg7","switchText":"LanguageSelectionMenu_switchText__YManQ","handle":"LanguageSelectionMenu_handle__aNhfh"};